import styled from "@emotion/styled";
import { Paper } from "@mui/material";

export const InsumoCard = styled(Paper)`
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 1rem;
    margin-top: 0.5rem;
`